<script setup>
import FormBase from "./FormBase.vue";
import { FormInput } from "@Components/Form";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import { AnthropicIcon } from "@Icons/index";
import { useStore } from "@/Stores/requiredSettings";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();
const store = useStore();

const form = useForm({
    api_key: props.settings?.api_key,
});

const submit = () => {
    if (form.processing) return;
    form.post("settings_api_update_anthropic").then(() => {
        store.refresh();
    });
};
</script>

<template>
    <FormBase @submit="submit" :form="form" :icon="AnthropicIcon" optional>
        <template #title>
            {{ __("Anthropic") }}
        </template>
        <template #description>
            <span class="block">{{ __("Utilisez les modèles Anthropic pour la génération vos textes.") }} </span>
        </template>
        <template #form>
            <FormInput v-model="form.api_key" :label="__('Clé API')" :errors="form.errors.get('api_key')" sensitive>
                <template #hint>
                    <a href="https://console.anthropic.com/settings/keys" target="_blank" class="font-bold text-gray-900 dark:text-white hover:underline">{{
                        __("Obtenir la clé API")
                    }}</a>
                </template>
            </FormInput>
        </template>
    </FormBase>
</template>
